module.exports = __webpack_public_path__ + "static/media/arrow_down.a5dd2a34.png";